import { useState } from "react";
import { Minus, Plus, ShoppingBag } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { inr } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import CheckoutDialog from "@/components/site/CheckoutDialog";
import { useLang } from "@/context/LangContext";

export default function CartSheet() {
  const { items, setQty, total, open, setOpen } = useCart();
  const { t, item } = useLang();
  const [checkout, setCheckout] = useState(false);

  return (
    <>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent className="bg-parchment w-full sm:max-w-md flex flex-col" data-testid="cart-sheet">
          <SheetHeader><SheetTitle className="font-serif text-3xl text-forest-800">{t("cart.title")}</SheetTitle></SheetHeader>
          <div className="flex-1 overflow-y-auto mt-6 space-y-4">
            {items.length === 0 && (
              <div className="text-center py-16 text-[#8A978E]" data-testid="cart-empty">
                <ShoppingBag className="w-10 h-10 mx-auto mb-3" /> {t("cart.empty")}
              </div>
            )}
            {items.map((i) => (
              <div key={i.id} className="flex gap-4 items-center bg-white rounded-xl p-3 border border-parchment-300" data-testid={`cart-item-${i.id}`}>
                <img src={i.image} alt={i.name} className="w-16 h-16 rounded-lg object-cover" />
                <div className="flex-1 min-w-0">
                  <p className="font-semibold text-forest-800 text-sm truncate">{item(i.id, i.name, "")[0]}</p>
                  <p className="text-sm text-[#57645A]">{inr(i.price)}</p>
                </div>
                <div className="flex items-center gap-2">
                  <button onClick={() => setQty(i.id, i.qty - 1)} className="w-7 h-7 rounded-full border grid place-items-center" data-testid={`cart-dec-${i.id}`}><Minus className="w-3 h-3" /></button>
                  <span className="w-5 text-center text-sm font-semibold" data-testid={`cart-qty-${i.id}`}>{i.qty}</span>
                  <button onClick={() => setQty(i.id, i.qty + 1)} className="w-7 h-7 rounded-full border grid place-items-center" data-testid={`cart-inc-${i.id}`}><Plus className="w-3 h-3" /></button>
                </div>
              </div>
            ))}
          </div>
          {items.length > 0 && (
            <div className="border-t border-parchment-300 pt-5 space-y-4">
              <div className="flex justify-between items-baseline">
                <span className="text-[#57645A]">{t("cart.total")}</span>
                <span className="font-serif text-3xl font-bold text-forest-800" data-testid="cart-total">{inr(total)}</span>
              </div>
              <button onClick={() => setCheckout(true)} className="w-full bg-forest-800 hover:bg-forest-700 text-parchment font-semibold py-3.5 rounded-full transition-colors" data-testid="cart-checkout-button">
                {t("cart.checkout")}
              </button>
            </div>
          )}
        </SheetContent>
      </Sheet>
      <CheckoutDialog open={checkout} onOpenChange={setCheckout} kind="cart" title={t("cart.items", { n: items.length })} total={total} />
    </>
  );
}
